const state = {
  recommendMemberData: { // 推荐会员数据
    vipDriverInfo: null, // 司机会员信息
    recommendMemberVipConfig: null, // 推荐套餐配置
    recommendMemberItem: null, // 推荐的套餐详情信息
  },
};

// getters
const getters = {
  getRecommendMemberData(state) {
    return state.recommendMemberData;
  },
};

// actions
const actions = {

};

// mutations
const mutations = {
  setRecommendMemberData(state, data) {
    state.recommendMemberData = data;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
